import { t } from "@lingui/macro";
import { Button, DatePicker, Input, Select } from "antd";
import { UndoOutlined } from "@ant-design/icons";
import { Dispatch, SetStateAction } from "react";
import { formRequestQueryDefault } from "store/filter/index.slice";
import {
	FormRequestQueryParams,
	FORM_REQUEST_STATUS,
} from "../form-request/type";
import { FormRequestStatusElements } from "../form-request/constant";
import { translate } from "utils";
import moment, { Moment } from "moment";
const { Option } = Select;
const { RangePicker } = DatePicker;
export interface SearchParams {
	query: FormRequestQueryParams;
	setQuery: Dispatch<SetStateAction<FormRequestQueryParams>>;
	getList: (query: FormRequestQueryParams) => void;
}

const Search = ({ query, setQuery, getList }: SearchParams) => {
	const { startDate, endDate } = query;
	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setQuery((prev: FormRequestQueryParams) => ({
			...prev,
			name: event.target.value,
		}));
	};
	const handleSearch = (value: string) => {
		const newQuery = {
			...query,
			name: value || null,
			skip: 0,
		};
		getList(newQuery);
	};

	const handleReset = () => {
		getList(formRequestQueryDefault);
	};
	const handleChangeStatus = (value: FORM_REQUEST_STATUS) => {
		const newQuery = {
			...query,
			status: value || null,
		};
		getList(newQuery);
	};
	const handleChangeRangeDate = (
		values: [Moment | null, Moment | null] | null,
	) => {
		const [start, end] = values || [];
		const newQuery = {
			...query,
			startDate: start?.startOf("day")?.toISOString(),
			endDate: end?.endOf("day")?.toISOString(),
			skip: 0,
		};
		getList(newQuery);
	};
	return (
		<div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 2xl:grid-cols-5 gap-4">
			<div>
				<p>{t`Name`}</p>
				<Input.Search
					placeholder={t`Input name`}
					onSearch={handleSearch}
					onChange={handleChange}
					value={query.name || ""}
				/>
			</div>
			<div>
				<p>{t`Status`}</p>
				<Select
					placeholder={t`Select status`}
					className="w-full"
					value={query.status}
					onChange={handleChangeStatus}
					allowClear
				>
					<Option value={null}>{t`All`}</Option>
					{Object.values(FormRequestStatusElements).map(el => (
						<Option key={el.value} value={el.value}>
							<span className={`text-[${el.color}]`}>
								{translate(el.label)}
							</span>
						</Option>
					))}
				</Select>
			</div>
			<div>
				<p>{t`Request date`}</p>
				<RangePicker
					className="w-full"
					value={[
						startDate ? moment(startDate) : null,
						endDate ? moment(endDate) : null,
					]}
					format="YYYY-MM-DD"
					allowEmpty={[true, true]}
					allowClear
					onChange={handleChangeRangeDate}
				/>
			</div>
			<div className="flex justify-between">
				<Button
					icon={<UndoOutlined />}
					className="flex items-center self-end rounded"
					onClick={handleReset}
				>
					{t`Reset`}
				</Button>
			</div>
		</div>
	);
};

export default Search;
